import { gql } from 'graphql-tag';

export const INSERT_LEAD = gql`
  mutation InsertLead($leadInput: SalesforceLeadInput!) {
    salesforceInsertLead(leadInput: $leadInput) {
      message
    }
  }
`;
